import { useAuthEventListener } from 'lib/auth';
import SessionCart from './SessionCart';
import { IS_CART_MERGING_LOCAL_STORAGE_KEY } from './constants';

const useForgetCartOnLogout = () => {
  useAuthEventListener({
    onSignOutSuccess: () => {
      SessionCart.forget();
      if (window.localStorage) {
        localStorage.removeItem(IS_CART_MERGING_LOCAL_STORAGE_KEY);
      }
    },
  });
};

export default useForgetCartOnLogout;
